module.exports = __webpack_public_path__ + "static/media/bodycell-sm-eraser-cream.fa0ec2ef.webp";